import {
    ISearchDeviceMDMSuccessAction,
    IUpdateDeviceMDMFilterSuccessAction,
    IUpdateSortDeviceMDMSuccessAction
} from '../actions/load-search-locations';
import * as moment from 'moment'
import { IServiceRequestsState } from '../state';

export type searchDeviceMDMAction =
ISearchDeviceMDMSuccessAction | IUpdateDeviceMDMFilterSuccessAction;
export type updateSortLocationSuccessAction= IUpdateSortDeviceMDMSuccessAction;

export const updateDeviceLocationSuccessReducer =
 (state: IServiceRequestsState, action: IUpdateDeviceMDMFilterSuccessAction) => {
     const updatedFilters = (action as IUpdateDeviceMDMFilterSuccessAction).data.locations.filters;
     const updatedOriginal = (action as IUpdateDeviceMDMFilterSuccessAction).data.locations.original;

     return ({
         ...state,
         search: {
             locations: {
                 filters: updatedFilters !== undefined ? updatedFilters : state.search.locations.filters,
                 original: updatedOriginal !== undefined ? updatedOriginal : state.search.locations.original
             }
         }
     })
 };
export const searchDeviceLocationsSuccessReducer =
// eslint-disable-next-line @typescript-eslint/no-unused-vars
(state: IServiceRequestsState, action: searchDeviceMDMAction) => {
    const filters = state.search.locations.filters;
    const filterOptions = [
        {chargeable: null,
            compliance: null,
            enrollment: null,
            lastSeen: null,
            ownedBy: null,
            operatingSystem: null,
            IMEI: null
        }]

    filters.location.map((el) => {
        switch (el.label) {
            case 'chargeable' :
                filterOptions[0].chargeable = el.value
                break;
            case 'compliance' :
                filterOptions[0].compliance = el.value
                break;
            case 'enrollment' :
                filterOptions[0].enrollment = el.value
                break;
            case 'lastSeen' :
                filterOptions[0].lastSeen = el.value
                break;
            case 'ownedBy' :
                filterOptions[0].ownedBy = el.value
                break;
            case 'operatingSystem' :
                filterOptions[0].operatingSystem = el.value
                break;
            case 'IMEI' :
                filterOptions[0].IMEI = el.value
                break;
        }
    }
    )

    let filteredLocations = state.deviceTypeData.data.originaldeviceTypeList;
    let startDateMomentObj = null;
    let lastDateMomentObj = null;
    if (filters.location.length) {
        filteredLocations = state.deviceTypeData.data.originaldeviceTypeList;

        filterOptions.filter((key) => {
            if (key.lastSeen) {
                if (key.lastSeen === 'Less than 7 Days') {
                    key.lastSeen = '0-6';
                } else if (key.lastSeen === '7 to 30 days') {
                    key.lastSeen = '7-30';
                } else {
                    key.lastSeen = '30-99999';
                }
                const desiredDate = key.lastSeen.split('-')
                const startDate = desiredDate[0];
                const lastDate = desiredDate[1];
                startDateMomentObj = moment().subtract('days', startDate).format('YYYY-MM-DDTHH:mm:ss.SSS');
                lastDateMomentObj = moment().subtract('days', lastDate).format('YYYY-MM-DDTHH:mm:ss.SSS');

            }
            filteredLocations = filteredLocations.filter((v) => {
                return (key.chargeable === v.chargeable || key.chargeable === null)
                    && (key.enrollment === v.enrollment || key.enrollment == null)
                    && (startDateMomentObj >= v.lastSeen && lastDateMomentObj <= v.lastSeen || key.lastSeen == null)
                    && (key.IMEI === v.IMEI || key.IMEI == null)
                    && (key.compliance === v.compliance || key.compliance == null)
                    && (key.ownedBy === v.ownedBy || key.ownedBy == null)
                    && ((key.operatingSystem && key.operatingSystem !== undefined &&
                        key.operatingSystem.split('-')[1]) === (v.platformId && v.platformId !== undefined &&
                        v.platformId.toString()) ||
                        key.operatingSystem == null)
            })
        })
    }
    return ({
        ...state,
        deviceTypeData: {
            ...state.deviceTypeData,
            data: {
                ...state.deviceTypeData.data,
                deviceTypeList: filteredLocations
            }
        }
    })
};
